(function() {
  var stages = Array.prototype.slice.call(document.querySelectorAll('[data-special-feature-stage]'));
  if (!stages.length) return;

  if (!window.gsap || !window.ScrollTrigger) return;

  gsap.registerPlugin(ScrollTrigger);

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion) return;

  var media = gsap.matchMedia();
  var pageWrapper = document.querySelector('.page-wrapper');
  var scrollContainer = pageWrapper && pageWrapper.scrollHeight > pageWrapper.clientHeight
    ? pageWrapper
    : window;

  media.add('(min-width: 1025px)', function() {
    function stickyOffset() {
      var tabs = document.querySelector('.firefly-product-detail__tabs');
      var tabsHeight = tabs ? tabs.offsetHeight : 0;
      return Math.round(tabsHeight);
    }

    function applyStickyOffset(stage) {
      var offset = stickyOffset();
      var viewportHeight = scrollContainer === window ? window.innerHeight : scrollContainer.clientHeight;
      var availableHeight = Math.max(480, viewportHeight - offset);
      stage.style.setProperty('--special-feature-sticky-offset', offset + 'px');
      stage.style.setProperty('--special-feature-available-height', availableHeight + 'px');
    }

    stages.forEach(function(stage, index) {
      var clearLayer = stage.querySelector('[data-special-feature-clear]');
      var blurLayer = stage.querySelector('[data-special-feature-blur]');
      var shade = stage.querySelector('[data-special-feature-shade]');
      var copy = stage.querySelector('[data-special-feature-copy]');
      var items = Array.prototype.slice.call(stage.querySelectorAll('[data-special-feature-item]'));

      if (!clearLayer || !blurLayer || !items.length) return;

      gsap.set(clearLayer, { force3D: true });
      gsap.set(blurLayer, { autoAlpha: 0, force3D: true });
      gsap.set(shade, { autoAlpha: 0, force3D: true });
      gsap.set(copy, { force3D: true });
      gsap.set(items, { autoAlpha: 0, y: 70, force3D: true });
      applyStickyOffset(stage);

      var effectHoldDistance = 320;
      var effectHoldDuration = 0.32;

      var timeline = gsap.timeline({
        defaults: { ease: 'none' },
        scrollTrigger: {
          id: 'firefly-special-feature-' + index,
          trigger: stage,
          scroller: scrollContainer === window ? undefined : scrollContainer,
          start: function() {
            return 'top top+=' + stickyOffset();
          },
          end: function() {
            return '+=' + Math.round(stage.offsetHeight * 0.85 + effectHoldDistance);
          },
          scrub: 0.45,
          pin: true,
          pinSpacing: true,
          anticipatePin: 1,
          fastScrollEnd: false,
          invalidateOnRefresh: true,
          refreshPriority: index,
          onRefreshInit: function() {
            applyStickyOffset(stage);
          },
          onRefresh: function() {
            applyStickyOffset(stage);
          }
        }
      });

      timeline
        .to(clearLayer, { autoAlpha: 0.16, scale: 1.06 }, effectHoldDuration)
        .to(blurLayer, { autoAlpha: 1 }, effectHoldDuration)
        .to(shade, { autoAlpha: 0.35 }, effectHoldDuration)
        .fromTo(copy, {
          y: function() {
            var viewportHeight = scrollContainer === window ? window.innerHeight : scrollContainer.clientHeight;
            var startRatio = viewportHeight <= 1080 ? 0.7 : 0.65;
            return Math.round(stage.offsetHeight * startRatio);
          }
        }, { y: 24 }, effectHoldDuration)
        .to(items, {
          autoAlpha: 1,
          y: 0,
          duration: 0.32,
          stagger: 0.035,
          ease: 'power2.out'
        }, effectHoldDuration + 0.28);
    });

    var refresh = function() {
      ScrollTrigger.refresh();
    };

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(refresh);
    }

    window.addEventListener('load', refresh, { once: true });

    return function() {
      window.removeEventListener('load', refresh);
    };
  });

})();
